// Mock data for Mr Back at it website

export const services = [
  {
    id: 1,
    title: "Content Creation",
    description: "Premium video content, social media posts, and brand storytelling that captures attention and drives engagement.",
    icon: "video",
    features: ["Video Production", "Social Media Content", "Brand Storytelling", "Photo Editing"]
  },
  {
    id: 2,
    title: "App Development",
    description: "Custom mobile and web applications built with cutting-edge technology to bring your ideas to life.",
    icon: "smartphone",
    features: ["Mobile Apps", "Web Applications", "UI/UX Design", "API Integration"]
  },
  {
    id: 3,
    title: "Advertising",
    description: "Strategic advertising campaigns that reach your target audience and maximize ROI across all platforms.",
    icon: "megaphone",
    features: ["Social Media Ads", "Google Ads", "Campaign Strategy", "Analytics & Reporting"]
  }
];

export const apps = [
  {
    id: 1,
    name: "TaskMaster Pro",
    description: "Ultimate productivity app with AI-powered task management and team collaboration features.",
    price: 29.99,
    category: "productivity",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&q=80",
    rating: 4.8,
    downloads: "10K+",
    featured: true
  },
  {
    id: 2,
    name: "FitTrack Elite",
    description: "Comprehensive fitness tracking app with personalized workout plans and nutrition guidance.",
    price: 19.99,
    category: "health",
    image: "https://images.unsplash.com/photo-1461897104016-0b3b00cc81ee?w=800&q=80",
    rating: 4.6,
    downloads: "8K+",
    featured: true
  },
  {
    id: 3,
    name: "BudgetWise",
    description: "Smart budgeting tool that helps you manage finances, track expenses, and achieve savings goals.",
    price: 14.99,
    category: "finance",
    image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&q=80",
    rating: 4.7,
    downloads: "12K+",
    featured: false
  },
  {
    id: 4,
    name: "CreativeHub",
    description: "All-in-one design tool for creators with templates, assets, and collaboration features.",
    price: 39.99,
    category: "design",
    image: "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&q=80",
    rating: 4.9,
    downloads: "15K+",
    featured: true
  },
  {
    id: 5,
    name: "LearnFlow",
    description: "Interactive learning platform with courses, quizzes, and progress tracking for skill development.",
    price: 24.99,
    category: "education",
    image: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=800&q=80",
    rating: 4.5,
    downloads: "6K+",
    featured: false
  },
  {
    id: 6,
    name: "SocialBoost",
    description: "Social media management tool with scheduling, analytics, and content optimization features.",
    price: 34.99,
    category: "marketing",
    image: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=800&q=80",
    rating: 4.7,
    downloads: "9K+",
    featured: false
  }
];

export const contentPieces = [
  {
    id: 1,
    title: "Modern Brand Identity Pack",
    description: "Complete brand identity package including logos, color palettes, and style guides.",
    price: 149.99,
    type: "design",
    image: "https://images.unsplash.com/photo-1626785774625-ddcddc3445e9?w=800&q=80",
    featured: true
  },
  {
    id: 2,
    title: "Social Media Template Bundle",
    description: "50+ professionally designed templates for Instagram, Facebook, and Twitter.",
    price: 49.99,
    type: "templates",
    image: "https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?w=800&q=80",
    featured: true
  },
  {
    id: 3,
    title: "Video Intro Animations",
    description: "Premium video intro animations perfect for YouTube, TikTok, and brand videos.",
    price: 79.99,
    type: "video",
    image: "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=800&q=80",
    featured: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "CEO, TechStart Inc",
    content: "These digital products transformed how we approach business growth. The strategies are practical, actionable, and actually work!",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&q=80"
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Marketing Director",
    content: "The advertising campaigns delivered amazing ROI. Professional, creative, and always delivers on time.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&q=80"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    role: "Founder, Creative Studio",
    content: "Best investment for our business! The app development and content creation services are top-notch.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&q=80"
  }
];

export const stats = [
  { label: "Projects Completed", value: "250+" },
  { label: "Happy Clients", value: "180+" },
  { label: "Apps Launched", value: "45+" },
  { label: "Content Pieces", value: "1000+" }
];

export const categories = [
  { id: "all", name: "All Products" },
  { id: "productivity", name: "Productivity" },
  { id: "health", name: "Health & Fitness" },
  { id: "finance", name: "Finance" },
  { id: "design", name: "Design" },
  { id: "education", name: "Education" },
  { id: "marketing", name: "Marketing" }
];
